<template>
  <v-container fluid>
    <data-table
      :filters="filters"
      :limit="7"
      url="/report_downloads"
      content="reportDownloadLists">
      <v-layout row wrap slot="title">
        <v-flex md9>
          <p class="headline mt-3">
            Descarga
          </p>
        </v-flex>
        <v-flex md3 class="text-xs-right">
          <v-btn class="k-orange-linear white--text mr-0" large @click="dialog = !dialog">
            DESCARGAR
          </v-btn>
        </v-flex>
      </v-layout>
      <template slot="navigation-bar">
        <v-flex lg6>
          <v-text-field
            v-model="filters.search"
            label="Buscar..."
            color="black"
            solo>
          </v-text-field>
        </v-flex>
        <v-flex lg2 pl-2>
          <v-select
            v-model="filters.status"
            :items="statuses"
            color="grey"
            solo>
          </v-select>
        </v-flex>
        <v-flex lg2 pl-2>
          <v-menu
            ref="from"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="filters['min-created_at']"
            transition="scale-transition"
            min-width="290px"
            lazy
            offset-y
            full-width>
              <v-text-field
                slot="activator"
                v-model="dateMinFormated"
                class="k-orange-linear-text"
                prepend-icon="event"
                label="Desde"
                readonly
                solo>
              </v-text-field>
              <v-date-picker
                v-model="filters['min-created_at']"
                @input="$refs.from.save(filters['min-created_at'])"
                locale="es"
                :max="maxDate"
                color="k-orange-linear">
              </v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex lg2 pl-2>
          <v-menu
            ref="to"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="filters['max-created_at']"
            transition="scale-transition"
            min-width="290px"
            full-width
            offset-y
            lazy>
              <v-text-field
                slot="activator"
                v-model="dateMaxFormated"
                class="k-orange-linear-text"
                prepend-icon="event"
                label="Hasta"
                readonly
                solo>
              </v-text-field>
              <v-date-picker
                v-model="filters['max-created_at']"
                @input="$refs.to.save(filters['max-created_at'])"
                locale="es"
                :max="maxDate"
                color="k-orange-linear">
              </v-date-picker>
          </v-menu>
        </v-flex>
      </template>
    </data-table>
    <save-dialog
      title="Descargar"
      :dialog="dialog"
      :form="form"
      route="report_downloads"
      :edit="false"
      :hasMore="false"
      :more="false">
      <template slot="content">
        <v-layout row wrap>
          <v-flex xs12>
            <v-select
              v-model="form.type_of_file"
              v-validate="'required'"
              data-vv-name="entity"
              data-vv-as="entidad"
              :error-messages="errors.collect('entity')"
              :items="entities"
              label="Entidad"
              color="black">
            </v-select>
          </v-flex>
        </v-layout>
      </template>
    </save-dialog>
    <v-dialog v-model="showError" scrollable persistent max-width="600px">
      <v-card>
        <v-toolbar flat class="k-orange-linear">
          <v-toolbar-title class="white--text pl-4 py-3">
            Error
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text px-4>
          <v-layout row wrap px-2>
            <v-flex xs12>
              <pre>
                {{ log }}
              </pre>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-layout row wrap  px-2>
            <v-flex text-xs-right>
              <v-btn flat color="black" @click="showError = false">
                CERRAR
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import dataTable from '@/components/global/DataTable';
import reportDownloadLists from '@/components/report_download/ReportDownloadList';
import saveDialog from '@/components/global/SaveDialog';
import saveDialogMixin from '@/mixins/saveDialog';
import EventBus from '@/event-bus';

Vue.component('reportDownloadLists', reportDownloadLists);

export default {
  components: {
    'save-dialog': saveDialog,
    'data-table': dataTable,
  },
  mixins: [
    saveDialogMixin,
  ],
  created() {
    EventBus.$on('showError', (log) => {
      this.log = log;
      this.showError = true;
    });
  },
  destroyed() {
    EventBus.$off('showError');
  },
  data() {
    return {
      showError: false,
      log: '',
      from: false,
      to: false,
      maxDate: moment().format('YYYY-MM-DD'),
      filters: {
        search: '',
        status: '',
        'min-created_at': moment().format('YYYY-MM-DD'),
        'max-created_at': moment().format('YYYY-MM-DD'),
      },
      entities: [
        {
          value: 'email',
          text: 'Emails Invalidos',
        },
        {
          value: 'mobile_phone_and_email',
          text: 'Celulares y Emails Invalidos',
        },
        {
          value: 'mobile_phone',
          text: 'Celulares Invalidos',
        },
        {
          value: 'local_phone',
          text: 'Telefonos Fijos Invalidos',
        },
      ],
      statuses: [
        {
          value: '',
          text: 'Estados',
        },
        {
          value: 'procesado',
          text: 'Procesado',
        },
        {
          value: 'procesando',
          text: 'Procesando',
        },
        {
          value: 'error',
          text: 'Error',
        },
      ],
      form: {
        type_of_file: '',
        date: '',
      },
    };
  },
  computed: {
    dateMaxFormated() {
      return moment(this.filters['max-created_at'], 'YYYY-MM-DD').format('DD/MM/YYYY');
    },
    dateMinFormated() {
      return moment(this.filters['min-created_at'], 'YYYY-MM-DD').format('DD/MM/YYYY');
    },
  },
};
</script>

<style scoped>
pre {
  background: #ddd;
  height: 200px;
  white-space: normal;    /* Internet Explorer 5.5+ */
}
</style>



// WEBPACK FOOTER //
// src/components/report_download/Index.vue